import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MerchantAccountListItem } from '../../models';
import { GridApi, ColumnApi, GridOptions } from 'ag-grid-community';
import { AccountStatusComponent, ActionsComponent, PersonComponent } from '../../cell-renderers';
import { MerchantProfileFilter, UniversityPersonFilter, AccountStatusFilter } from '../../filters';

@Component({
    selector: 'app-merchant-account-list',
    templateUrl: './merchant-account-list.component.html',
    styleUrls: ['./merchant-account-list.component.css']
})
export class MerchantAccountListComponent implements OnInit {

    @Input() merchantAccounts: MerchantAccountListItem[];
    @Input() headingText: string;
    @Input() isAdmin: boolean;
    @Input() showMerchantProfile: boolean = true;
    @Input() smallHeader: boolean = false;

    showLoading = false;

    private gridApi: GridApi;
    private gridColumnApi: ColumnApi;
    gridOptions: GridOptions;

    constructor(
    ) {

    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{
            columnDefs: [
                {
                    headerName: 'Merchant/Location ID',
                    field: 'merchantId',
                    filter: 'agTextColumnFilter',
                    filterParams: {
                        filterOptions: ['startsWith'],
                        suppressAndOrCondition: true
                    }
                },
                {
                    headerName: 'Merchant Profile',
                    field: 'merchantProfileName',
                    filter: 'merchantProfileFilter',
                    hide: !this.showMerchantProfile
                },
                {
                    headerName: 'Merchant Name',
                    field: 'preferredMerchantName',
                    filter: 'agTextColumnFilter',
                    filterParams: {
                        filterOptions: ['startsWith', 'contains'],
                        suppressAndOrCondition: true
                    }
                },
                {
                    headerName: 'Contact',
                    field: 'contact.displayName',
                    cellRendererFramework: PersonComponent,
                    filter: 'universityPersonFilter'
                },
                {
                    headerName: 'Account Status',
                    field: 'statusString',
                    cellRendererFramework: AccountStatusComponent,
                    filter: 'accountStatusFilter'
                },
                {
                    cellRendererFramework: ActionsComponent,
                    cellRendererParams: {
                        isAdmin: this.isAdmin
                    },
                    minWidth: 55,
                    maxWidth: 65
                }
            ],
            defaultColDef: {
                sortable: true
            },
            frameworkComponents: {
                merchantProfileFilter: MerchantProfileFilter,
                accountStatusFilter: AccountStatusFilter,
                universityPersonFilter: UniversityPersonFilter
            },
            animateRows: true,
            suppressMenuHide: true
        }
    }

    onGridReady(params: { api: GridApi; columnApi: ColumnApi; type: string }) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.autoSizeAll(); // will resize all visible columns
        this.gridApi.sizeColumnsToFit(); // will resize all columns to fit visible.
    }

    getTotal() {
        if (this.gridApi) {
            return this.gridApi.getDisplayedRowCount();
        }
        return 0;
    }

    private autoSizeAll() {
        const allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach((c) => allColumnIds.push(c.getColId()));
        this.gridColumnApi.autoSizeColumns(allColumnIds);
    }
}